import { render, staticRenderFns } from "./PremiumFeatureIntroduce.vue?vue&type=template&id=dfb62fdc&scoped=true"
import script from "./PremiumFeatureIntroduce.vue?vue&type=script&lang=ts"
export * from "./PremiumFeatureIntroduce.vue?vue&type=script&lang=ts"
import style0 from "./PremiumFeatureIntroduce.vue?vue&type=style&index=0&id=dfb62fdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb62fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb62fdc')) {
      api.createRecord('dfb62fdc', component.options)
    } else {
      api.reload('dfb62fdc', component.options)
    }
    module.hot.accept("./PremiumFeatureIntroduce.vue?vue&type=template&id=dfb62fdc&scoped=true", function () {
      api.rerender('dfb62fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PremiumFeatureIntroduce.vue"
export default component.exports